// src/lang/index.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhLocale from './zh'
import enLocale from './en'
import jaLocale from './ja'
import koLocale from './ko'
import frLocale from './fr'
import deLocale from './de'
import esLocale from './es'
import ruLocale from './ru'
import ptLocale from './pt'
import itLocale from './it'
import arLocale from './ar'
import hiLocale from './hi'
import thLocale from './th'
import trLocale from './tr'
import idLocale from './id'
import viLocale from './vi'

Vue.use(VueI18n)

const messages = {
    zh: { ...zhLocale }, // 中文
    en: { ...enLocale }, // 英语
    ja: { ...jaLocale }, // 日语
    ko: { ...koLocale }, // 韩语
    fr: { ...frLocale }, // 法语
    de: { ...deLocale }, // 德语
    es: { ...esLocale }, // 西班牙语
    ru: { ...ruLocale }, // 俄语
    pt: { ...ptLocale }, // 葡萄牙语
    it: { ...itLocale }, // 意大利语
    ar: { ...arLocale }, // 阿拉伯语
    hi: { ...hiLocale }, // 印地语
    th: { ...thLocale }, // 泰语
    tr: { ...trLocale }, // 土耳其语
    id: { ...idLocale }, // 印度尼西亚语
    vi: { ...viLocale }, // 越南语
}

const i18n = new VueI18n({
    silentFallbackWarn: true,
    locale: localStorage.getItem("languageInfo") ? JSON.parse(localStorage.getItem("languageInfo")).lang : 'en', // 设置默认语言
    messages      // 注入语言包
})

export default i18n